import React from 'react';
import { useNavigate } from 'react-router-dom';

const Payment: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="space-y-4">
      <h1 className="text-2xl font-bold">Payment</h1>
      
      <div className="card bg-base-100 shadow-sm">
        <div className="card-body">
          <h2 className="card-title justify-center">Scan QR Code to Pay</h2>
          
          <div className="flex justify-center my-8">
            {/* Placeholder QR Code */}
            <div className="w-64 h-64 bg-base-200 rounded-lg flex items-center justify-center">
              <div className="text-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-24 w-24 mx-auto mb-4 text-base-content/20"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 4v1m6 11h2m-6 0h-2v4m0-11v3m0 0h.01M12 12h4.01M16 20h4M4 12h4m12 0h.01M5 8h2a1 1 0 001-1V5a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1zm12 0h2a1 1 0 001-1V5a1 1 0 00-1-1h-2a1 1 0 00-1 1v2a1 1 0 001 1zM5 20h2a1 1 0 001-1v-2a1 1 0 00-1-1H5a1 1 0 00-1 1v2a1 1 0 001 1z"
                  />
                </svg>
                <p className="text-sm text-base-content/60">
                  QR Code Placeholder
                </p>
              </div>
            </div>
          </div>
          
          <div className="divider">OR</div>
          
          <div className="text-center space-y-2">
            <p className="text-sm text-base-content/60">
              Use the following bank details:
            </p>
            <div className="bg-base-200 rounded-lg p-4 space-y-1">
              <p className="font-mono text-sm">Bank: Example Bank</p>
              <p className="font-mono text-sm">Account: 1234-5678-9012</p>
              <p className="font-mono text-sm">Name: Kanoon Technology</p>
            </div>
          </div>
          
          <button
            onClick={() => navigate(-1)}
            className="btn btn-outline mt-4"
          >
            Back to Booking
          </button>
        </div>
      </div>
    </div>
  );
};

export default Payment;